import { registerModuleDataProvider } from '../../providers/CustomDataProvider';
import { bannersDataProvider } from './dataProvider';

// 注册 banners 模块的数据提供者
export function initBannersDataProvider() {
  registerModuleDataProvider('banners', bannersDataProvider);
}

// 自动初始化
initBannersDataProvider();





